import {
  Box,
  Button,
  Divider,
  FormControl,
  InputLabel,
  Menu,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import DateSetter from "../DatePicker";
import moment from "moment";
import CustomSelect from "./CustomSelect";
import TypeFilter from "./TypeFilter";
import AidFilter from "./AidFilter";
import ChannelFilter from "./ChannelFilter";
import AmountFilter from "./AmountFilter";
import IdFilter from "./IdFilter";
import PostcodeFilter from "./PostcodeFilter";
import { onGetDonations } from "../../src/utils/queries";
import { formatAsMoney } from "../../src/utils/services";
import { useAuthProvider } from "../../context/AuthProvider";
import ParticipantFilter from "./ParticipantFilter";
import NameOfCollectionFilter from "./NameOfCollectionFilter";
import PlateBuildingFilter from "./PlateBuildingFilter";
import GiftAidStatusFilter from "./GiftAidStatusFilter";
import PayerNameFilter from "./PayerNameFilter";
import DonorsFilter from "./DonorsFilter";

const TableFilter = ({
  value,
  setValue,
  setFilters,
  filters,
  defaultState,
  defaultLocalState,
  length,
  withChannel,
  withType,
  withGiftAid,
  isPlate,
  isEvent,
  isEnvelope,
  withParticipant,
  withDonor,
  donorsPage,
  isOtherIncome,
  isBuilding,
  isGiftAidClaimed,
  noAnonymous,
}) => {
  const [names, setNames] = useState([]);
  const { user } = useAuthProvider();

  const getTruthyCount = (filters) => {
    let count = 0;
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && key !== "status") {
        count++;
      }
    });

    if (length && count > length) {
      return true;
    } else if (length && count < length) {
      return false;
    }
    if (count > 2) {
      return true;
    }
    return false;
  };

  return (
    <div>
      <div
        style={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}
        className="dense-select"
      >
        <IdFilter setFilter={setFilters} value={value} setValue={setValue} />

        {withDonor && (
          <DonorsFilter
            setFilter={setFilters}
            value={value}
            setValue={setValue}
            isOther={[isEvent, isEnvelope]}
            noAnonymous={noAnonymous}
          />
        )}

        {donorsPage && (
          <PostcodeFilter
            setFilter={setFilters}
            value={value}
            setValue={setValue}
          />
        )}

        <CustomSelect
          setFilter={setFilters}
          filters={filters}
          value={value}
          setValue={setValue}
        />

        <AmountFilter
          setFilter={setFilters}
          value={value}
          setValue={setValue}
          filters={filters}
        />

        {withType && (
          <TypeFilter
            setFilter={setFilters}
            value={value}
            setNames={setNames}
            setValue={setValue}
            donation_type
          />
        )}

        {withParticipant && (
          <ParticipantFilter
            setFilter={setFilters}
            value={value}
            setNames={setNames}
            setValue={setValue}
            donation_type
          />
        )}

        {user?.type !== "individual" && withGiftAid && (
          <AidFilter setFilter={setFilters} value={value} setValue={setValue} />
        )}

        {withChannel && (
          <ChannelFilter
            setFilter={setFilters}
            value={value}
            setValue={setValue}
          />
        )}

        {isPlate && (
          <NameOfCollectionFilter
            setFilter={setFilters}
            value={value}
            setValue={setValue}
          />
        )}

        {isBuilding && (
          <PlateBuildingFilter
            setFilter={setFilters}
            value={value}
            setValue={setValue}
          />
        )}

        {isGiftAidClaimed && (
          <GiftAidStatusFilter
            setFilter={setFilters}
            value={value}
            setValue={setValue}
          />
        )}

        {isOtherIncome && (
          <PayerNameFilter
            setFilter={setFilters}
            value={value}
            setValue={setValue}
          />
        )}

        {getTruthyCount(filters) && (
          <Box
            display={"flex"}
            onClick={() => {
              setValue(defaultLocalState);
              setFilters(defaultState);
            }}
            sx={{ alignItems: "center", cursor: "pointer" }}
          >
            <Typography sx={{ color: "primary.main" }} variant="big">
              Clear
            </Typography>{" "}
            <i
              class="las la-times la-xl"
              style={{ color: "blue", display: "flex", alignItems: "center" }}
            ></i>
          </Box>
        )}
      </div>
      {getTruthyCount(filters) && (
        <>
          <Typography sx={{ color: "primary.main" }} variant="big">
            filtered by:{" "}
            {filters.date_range !== undefined && (
              <span>Date: from last {value.date_range}, </span>
            )}
            {filters.date_range === undefined &&
              (filters.date_from !== undefined ||
                filters.date_to !== undefined) && (
                <span>
                  Date: from {filters.date_from} to {filters.date_to},{" "}
                </span>
              )}
            {filters.donation_id !== undefined && (
              <span>Donation ID: {value.donation_id}, </span>
            )}
            {filters.donation_type !== undefined && (
              <span>Donation type: {names.join(" ,")}, </span>
            )}
            {filters.gift_aid !== undefined && (
              <span>Gift aid: {value.gift_aid}, </span>
            )}
            {filters.gift_aid_claimed !== undefined && (
              <span>Gift aid claimed: {value.gift_aid_claimed}, </span>
            )}
            {filters.amount_from !== undefined && (
              <span>
                Amount: from {formatAsMoney(value.amount_from)} to{" "}
                {formatAsMoney(value.amount_to)},{" "}
              </span>
            )}
            {filters.postal_code !== undefined && (
              <span>Post Code: {filters.postal_code}, </span>
            )}
            {/* {filters.channel !== undefined && !isPlate && (
              <span>Channel: {value.channel}, </span>
            )} */}
            {filters.donor_type !== undefined && (
              <span>Donor Type: {filters.donor_type}, </span>
            )}
            {filters.donation_name !== undefined && (
              <span>Name of collection: {filters.donation_name}</span>
            )}
            {filters.donor_name !== undefined && (
              <span>Donor: {filters.donor_name}</span>
            )}
            {filters.building_name !== undefined && (
              <span>Donor: {filters.building_name}</span>
            )}
          </Typography>
        </>
      )}
    </div>
  );
};

export default TableFilter;
